var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f73a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174461"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 328.754,
    x2: 315.254,
    xlinkHref: "#lg1",
    y1: 361.24,
    y2: 278.74
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 268.49,
    x2: 162.99,
    xlinkHref: "#lg1",
    y1: 198.003,
    y2: 254.503
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 101.69,
    x2: 208.292,
    xlinkHref: "#lg1",
    y1: 270.605,
    y2: 418.473
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 204.941,
    x2: 328.629,
    y1: 90.221,
    y2: 213.909
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45a2e0"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f73a0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f73a0"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 328.547,
    x2: 234.112,
    xlinkHref: "#lg2",
    y1: 181.051,
    y2: 86.615
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 273.841,
    x2: 253.513,
    xlinkHref: "#lg2",
    y1: 258.34,
    y2: 165.56
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 226.285,
    x2: 275.776,
    xlinkHref: "#lg3",
    y1: 107.257,
    y2: 107.257
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 226.285,
    x2: 275.776,
    xlinkHref: "#lg3",
    y1: 193.714,
    y2: 193.714
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.692,
    x2: 196.38,
    y1: 319.662,
    y2: 443.35
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e08e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fa953"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#43765a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43765a"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.298,
    x2: 101.862,
    xlinkHref: "#lg4",
    y1: 410.492,
    y2: 316.056
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.591,
    x2: 121.263,
    xlinkHref: "#lg4",
    y1: 487.781,
    y2: 395.001
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 94.036,
    x2: 143.527,
    xlinkHref: "#lg3",
    y1: 336.698,
    y2: 336.698
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 94.036,
    x2: 143.527,
    xlinkHref: "#lg3",
    y1: 423.155,
    y2: 423.155
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 337.191,
    x2: 460.879,
    y1: 319.662,
    y2: 443.35
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff755c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4181"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#843561",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a2f4d"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 460.797,
    x2: 366.362,
    xlinkHref: "#lg5",
    y1: 410.492,
    y2: 316.056
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 406.09,
    x2: 385.762,
    xlinkHref: "#lg5",
    y1: 487.781,
    y2: 395.001
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 358.535,
    x2: 408.026,
    xlinkHref: "#lg3",
    y1: 336.698,
    y2: 336.698
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 358.535,
    x2: 408.026,
    xlinkHref: "#lg3",
    y1: 423.155,
    y2: 423.155
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m436.853 294.023c0-30.052-7.334-58.42-20.296-83.421-8.294 4.863-18.05 10.674-25.755 15.527 10.262 20.443 16.051 43.504 16.051 67.894 0 79.773-61.832 145.374-140.087 151.398v-8.557c0-5.362-8.639-8.047-13.692-4.256l-24.852 18.649c-6.315 4.739-6.315 12.494 0 17.233l24.852 18.649c5.052 3.792 13.692 1.106 13.692-4.256v-7.405c94.81-6.084 170.087-85.135 170.087-181.455z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m413.005 188.322-7.263 4.131c-32.712-48.391-88.063-80.282-150.742-80.282-66.015 0-123.922 35.361-155.788 88.133l25.099 16.477c26.477-44.626 75.143-74.61 130.689-74.61 51.524 0 97.132 25.798 124.599 65.152l-6.596 3.752c-4.661 2.651-2.724 11.488 3.07 14.005l28.498 12.382c7.242 3.146 13.982-.688 14.979-8.52l3.923-30.823c.798-6.266-5.808-12.448-10.468-9.797z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228.222 468.492c-6.315-4.739-6.315-12.494 0-17.233l8.639-6.482c-75.21-8.995-133.713-73.161-133.713-150.753 0-22.388 4.885-43.652 13.623-62.803l5.622 3.87c4.417 3.041 11.527-2.553 11.269-8.865l-1.269-31.045c-.323-7.889-6.71-12.286-14.195-9.772l-29.453 9.896c-5.988 2.012-8.675 10.65-4.258 13.691l7.259 4.997c-11.895 24.165-18.598 51.326-18.598 80.03 0 94.152 71.923 171.817 163.712 180.95z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 140.279,
    fill: "url(#SVGID_4_)",
    r: 122.75
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m377.375 149.895c-2.15 27.834-13.589 53.064-31.227 72.603-8.944 9.906-19.484 18.358-31.211 24.933l-74.487-74.495-23.581-23.581c-11.517-10.367-17.334-25.387-17.334-42.103 0-31.282 23.932-55.206 55.214-55.206 16.716 0 31.735 5.809 42.103 17.326z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.148 222.498c-8.944 9.906-19.484 18.358-31.211 24.933-17.725 9.937-38.17 15.598-59.937 15.598-7.287 0-14.425-.633-21.36-1.853l-48.021-48.021c-3.729-2.15-3.565-7.42-.375-10.961l.094-.094c14.402-15.997 33.174-26.122 55.113-29.163 4.629-.641 9.398-.969 14.292-.969 27.036 0 51.414 9.82 68.764 27.889z",
    fill: "url(#SVGID_6_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 254.807,
    cy: 107.257,
    fill: "url(#SVGID_7_)",
    r: 56.641
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.121 202.624c-.35-.394-.702-.785-1.059-1.173-17.425-19.004-42.443-30.908-70.262-30.908-28.121 0-53.4 12.179-70.838 31.554-.03.033-.059.065-.088.098-3.917 4.349-1.123 11.306 4.701 11.886 17.354 1.729 41.846 2.804 69 2.804 24.531 0 46.891-.877 63.779-2.324 5.895-.505 8.697-7.513 4.767-11.937z",
    fill: "url(#SVGID_8_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 122.75,
    cy: 369.721,
    fill: "url(#SVGID_9_)",
    r: 122.75
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m245.126 379.336c-2.15 27.834-13.589 53.064-31.227 72.603-8.944 9.906-19.484 18.358-31.211 24.933l-74.488-74.495-23.58-23.58c-11.517-10.367-17.334-25.387-17.334-42.103 0-31.282 23.932-55.206 55.214-55.206 16.716 0 31.735 5.809 42.103 17.326z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.899 451.939c-8.944 9.906-19.484 18.358-31.211 24.933-17.725 9.937-38.17 15.598-59.937 15.598-7.287 0-14.425-.633-21.36-1.853l-48.021-48.021c-3.729-2.15-3.565-7.42-.375-10.961l.094-.094c14.402-15.997 33.174-26.122 55.113-29.163 4.629-.641 9.398-.969 14.292-.969 27.036 0 51.414 9.82 68.764 27.889z",
    fill: "url(#SVGID_11_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 122.558,
    cy: 336.698,
    fill: "url(#SVGID_12_)",
    r: 56.641
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.872 432.065c-.35-.394-.702-.785-1.059-1.173-17.425-19.004-42.443-30.908-70.262-30.908-28.121 0-53.4 12.179-70.838 31.554-.03.033-.059.065-.088.098-3.917 4.349-1.123 11.306 4.701 11.886 17.354 1.729 41.846 2.804 69 2.804 24.531 0 46.891-.877 63.779-2.324 5.895-.505 8.697-7.513 4.767-11.937z",
    fill: "url(#SVGID_13_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 387.25,
    cy: 369.721,
    fill: "url(#SVGID_14_)",
    r: 122.75
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m509.625 379.336c-2.15 27.834-13.589 53.064-31.227 72.603-8.944 9.906-19.484 18.358-31.211 24.933l-74.487-74.495-23.581-23.581c-11.517-10.367-17.334-25.387-17.334-42.103 0-31.282 23.932-55.206 55.214-55.206 16.716 0 31.735 5.809 42.103 17.326z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.398 451.939c-8.944 9.906-19.484 18.358-31.211 24.933-17.725 9.937-38.17 15.598-59.937 15.598-7.287 0-14.425-.633-21.36-1.853l-48.021-48.021c-3.729-2.15-3.565-7.42-.375-10.961.031-.031.063-.063.094-.094 14.402-15.997 33.174-26.122 55.113-29.163 4.629-.641 9.398-.969 14.292-.969 27.036 0 51.414 9.82 68.764 27.889z",
    fill: "url(#SVGID_16_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 387.057,
    cy: 336.698,
    fill: "url(#SVGID_17_)",
    r: 56.641
  }), /*#__PURE__*/React.createElement("path", {
    d: "m458.371 432.065c-.35-.394-.702-.785-1.059-1.173-17.425-19.004-42.443-30.908-70.262-30.908-28.121 0-53.4 12.179-70.838 31.554-.03.033-.059.065-.088.098-3.917 4.349-1.123 11.306 4.701 11.886 17.354 1.729 41.846 2.804 69 2.804 24.531 0 46.891-.877 63.779-2.324 5.895-.505 8.697-7.513 4.767-11.937z",
    fill: "url(#SVGID_18_)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.f2faf03ed4779f716de9dadeac711649.svg";
export { ForwardRef as ReactComponent };